import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { DoodProductModel } from '@core/models/product.model';
import { injectKioskGlobalSettings } from '@core/services/kiosk/kiosk-global-settings.token';
import { KioskProductCardAtomComponent } from '../kiosk-product-card-atom/kiosk-product-card-atom.component';
import { KioskProductCardV2AtomComponent } from '../kiosk-product-card-v2-atom /kiosk-product-card-v2-atom.component';
import { KioskProductCardV3AtomComponent } from '../kiosk-product-card-v3-atom/kiosk-product-card-v3-atom.component';
import { KioskProductCardV4AtomComponent } from '../kiosk-product-card-v4-atom/kiosk-product-card-v4-atom.component';
import { KioskProductCardV5AtomComponent } from '../kiosk-product-card-v5-atom/kiosk-product-card-v5-atom.component';
import { KioskProductCardV6AtomComponent } from '../kiosk-product-card-v6-atom/kiosk-product-card-v6-atom.component';

@Component({
  selector: 'app-kiosk-product-card-factory',
  standalone: true,
  imports: [
    CommonModule,
    KioskProductCardAtomComponent,
    KioskProductCardV2AtomComponent,
    KioskProductCardV3AtomComponent,
    KioskProductCardV4AtomComponent,
    KioskProductCardV5AtomComponent,
    KioskProductCardV6AtomComponent,
  ],
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
  template: `
    @if (productCardChoice() === 1) {
      <app-kiosk-product-card-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="isProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [class]="productCardType()"
      />
    } @else if (productCardChoice() === 2) {
      <app-kiosk-product-card-v2-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="isProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [class]="productCardType()"
      />
    } @else if (productCardChoice() === 3) {
      <app-kiosk-product-card-v3-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="isProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [class]="productCardType()"
      />
    } @else if (productCardChoice() === 4) {
      <app-kiosk-product-card-v4-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="isProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [class]="productCardType()"
      />
    } @else if (productCardChoice() === 5) {
      <app-kiosk-product-card-v5-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="isProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [class]="productCardType()"
      />
    } @else if (productCardChoice() === 6) {
      <app-kiosk-product-card-v6-atom
        [product]="product()"
        [quantity]="quantity()"
        (addProduct)="addProduct.emit()"
        (showProduct)="showProduct.emit()"
        [textColor]="textColor()"
        [cardColor]="cardColor()"
        [isProductAvailable]="isProductAvailable()"
        [buttonBackgroundColor]="buttonBackgroundColor()"
        [unavailableButtonBackground]="unavailableButtonBackground()"
        [unavailableButtonText]="unavailableButtonText()"
        [buttonTextColor]="buttonTextColor()"
        [class]="productCardType()"
      />
    }
  `,
})
export class KioskProductCardFactoryComponent {
  protected readonly kioskGlobalSettings = injectKioskGlobalSettings();

  protected readonly productCardChoice = computed(() => {
    return this.kioskGlobalSettings().productCard.choice;
  });

  protected readonly productCardType = computed(() => {
    return this.kioskGlobalSettings().productCard.styles.type;
  });

  protected readonly cardColSpan = computed(() => {
    return this.kioskGlobalSettings().productCard.cardColSpan;
  });

  readonly product = input.required<DoodProductModel>();
  readonly quantity = input.required<number | undefined>();
  readonly isProductAvailable = input<boolean>(true);
  readonly textColor = input<IContentBuilderFieldColor>();
  readonly cardColor = input<IContentBuilderFieldColor>();
  readonly buttonBackgroundColor = input<IContentBuilderFieldColor>();
  readonly unavailableButtonBackground = input<IContentBuilderFieldColor>();
  readonly unavailableButtonText = input<IContentBuilderFieldColor>();
  readonly buttonTextColor = input<IContentBuilderFieldColor>();

  readonly addProduct = output<void>();
  readonly showProduct = output<void>();
}
